<template>
 <div class="container-fluid py-1 py-md-2">
  <div class="content">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-lg-2 text-center">
        <CardData />
      </div>
      <div class="col-12 col-lg-5 pt-2">
        <label for="inputLogo" class="form-label label-view fw-bold fs-3">
          MitarbeiterCARDs Ladeliste hochladen
        </label>
        <input type="file" class="form-control" @change="onEmployerCardsListSet" ref="inputEmployerCardsList" accept=".xlsx, .csv, .xsl">
        <div class="text-end mt-4 mt-sm-2">
          <button type="submit" @click="sendUploadEmployerCardsList()" class="btn btn-primary">Ladeliste speichern >></button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-lg-12 ps-lg-3">
        <h1>MitarbeiterCARD-<span class="fw-bold">Verwaltung</span></h1>
        <p>Eine Auflistung aller Ihrer MitarbeiterCARDs</p>
        <div class="border border-radius rounded table-responsive p-3">
          <h3 class="mt-4">Ihre MitarbeiterCARDs</h3>
          <DataTable ref="mitarbeitercardstable" id="employer-cards-table" class="table table-hover align-middle mb-0" :data="employerCardsData" :columns="columns" :options="datatableOptions" width="100%">
            <thead>
              <tr>
                <th>Beladung aktiv</th>
                <th>Kartennummer</th>
                <th>Nachname</th>
                <th>Vorname</th>
                <th>Personalnummer</th>
                <th>Ladebetrag</th>
                <th>Ladefrequenz</th>
                <th>Ladezeitpunkt</th>
                <th>Nächster Ladetermin</th>
                <th>Bemerkungen</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>Beladung aktiv</th>
                <th>Kartennummer</th>
                <th>Nachname</th>
                <th>Vorname</th>
                <th>Personalnummer</th>
                <th>Ladebetrag</th>
                <th>Ladefrequenz</th>
                <th>Ladezeitpunkt</th>
                <th>Nächster Ladetermin</th>
                <th>Bemerkungen</th>
              </tr>
            </tfoot>
          </DataTable>
          <h5 class="mt-2">Aktuelle Ansicht exportieren</h5>
          <div id="export-buttons-container"></div>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import $ from 'jquery'
import CardData from '@/components/CardData.vue'
import DataTable from 'datatables.net-vue3'
import DataTablesLib from 'datatables.net-bs5'
import 'datatables.net-buttons-bs5'
import 'datatables.net-select-bs5'
DataTable.use(DataTablesLib)

export default {
  name: 'EmployerManageCards',
  components: {
    CardData,
    DataTable
  },
  data () {
    return {
      employerCardsListFile: undefined,
      dataTable: undefined,
      employerCardsData: [],
      columns: [
        {
          data: 'isChargingActive',
          targets: 0,
          orderable: false,
          searchable: false,
          width: '30px',
          className: 'dt-center',
          render: function(data, type, row, meta) {
            if (type === 'display') {
              const image = data === true ? require('../assets/img/icon-check.svg') : require('../assets/img/icon-x.svg')
              return '<img src="' + image + '" width="25">'
            } else {
              return data
            }
          },
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            if (cellData === false) {
              $(cell).addClass('table-warning')
            }
          }
        },
        {
          data: 'cardID',
          width: '130px',
          render: function(data, type, row, meta) {
            return String(data)
          },
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            if (rowData.isCardRegistered === true) {
              $(cell).addClass('table-success')
            }
          }
        },
        {
          data: 'lastName',
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            if (rowData.isCardRegistered === true) {
              $(cell).addClass('table-success')
            }
          }
        },
        {
          data: 'firstName',
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            if (rowData.isCardRegistered === true) {
              $(cell).addClass('table-success')
            }
          }
        },
        {
          data: 'personnelNumber',
          width: '100px',
          render: function(data, type, row, meta) {
            return String(data)
          }
        },
        {
          data: 'chargeAmount',
          width: '80px',
          render: function(data, type, row, meta) {
            if (data !== null && data !== '') {
              return data + '€'
            } else {
              return ''
            }
          }
        },
        {
          data: 'chargeFrequence',
          width: '100px'
        },
        {
          data: 'chargeTime',
          width: '140px'
        },
        {
          data: 'nextChargeTimestamp',
          width: '80px'
        },
        { data: 'personnelNote' }
      ],
      datatableOptions: {
        dom: 'frtlip',
        autoWidth: false,
        buttons: [
          {
            extend: 'csvHtml5',
            title: '',
            className: 'btn-primary',
            charset: 'utf-8',
            extension: '.csv',
            fieldSeparator: ';',
            fieldBoundary: '',
            bom: true,
            exportOptions: {
              orthogonal: 'export',
              columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            }
          },
          {
            extend: 'excelHtml5',
            title: '',
            className: 'btn-primary ms-2',
            exportOptions: {
              orthogonal: 'export',
              columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            },
            customize: function(xlsx, row) {
              var sheet = xlsx.xl.worksheets['Tabelle1.xml']
              $('row c[r^="B"]', sheet).attr('s', 50)
            }
          },
          {
            extend: 'pdfHtml5',
            title: '',
            className: 'btn-primary ms-2',
            orientation: 'landscape',
            exportOptions: {
              orthogonal: 'export',
              columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            }
          },
          {
            extend: 'print',
            title: '',
            className: 'btn-primary ms-2',
            text: 'Drucken',
            exportOptions: {
              orthogonal: 'export',
              columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            }
          }
        ],
        order: [[1, 'asc']],
        createdRow: function(row, rowData, index) {
          if (rowData.isCardActive === false) {
            $(row).addClass('table-danger')
          }
        },
        language: {
          search: 'Suchen',
          lengthMenu: 'Zeige _MENU_ MitarbeiterCARDs pro Seite',
          zeroRecords: 'Keine MitarbeiterCARDs gefunden',
          info: 'Zeige Einträge _START_ bis _END_ von _TOTAL_ Einträgen (Seite _PAGE_ von _PAGES_)',
          infoEmpty: 'Keine MitarbeiterCARDs gefunden',
          infoFiltered: '(gefiltert von _MAX_ MitarbeiterCARDs)',
          paginate: {
            first: 'Erste',
            last: 'Letzte',
            next: 'Nächste',
            previous: 'Vorherige'
          }
        }
      }
    }
  },
  methods: {
    async fetchEmployerCardsData () {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getEmployerCards').then(response => {
        this.employerCardsData = response
        this.$store.commit('SET_LOADING_STATUS', false)
      }).catch(() => { this.$store.commit('SET_LOADING_STATUS', false) })
        .finally(() => {
          this.$store.commit('SET_LOADING_STATUS', false)
        })
    },
    onEmployerCardsListSet (event) {
      this.employerCardsListFile = event.target.files[0]
    },
    sendUploadEmployerCardsList () {
      if (!this.employerCardsListFile) {
        this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Es wurde keine Datei zum Hochladen angegeben.' })
        return
      }

      this.$store.commit('DELETE_ALERTS')

      this.$store.commit('SET_LOADING_STATUS', true)
      const formData = new FormData()
      formData.append('employerCardsListFile', this.employerCardsListFile)
      this.$store.dispatch('uploadEmployerCardsList', formData)
        .then(() => {
          // clear form
          this.employerCardsListFile = undefined
          this.$refs.inputEmployerCardsList.value = null
        }).catch(() => {})
        .finally(() => { this.$store.commit('SET_LOADING_STATUS', false) })
    }
  },
  created () {
    this.fetchEmployerCardsData()
  },
  mounted () {
    this.dataTable = this.$refs.mitarbeitercardstable.dt
    this.dataTable.buttons().container().appendTo($('#export-buttons-container'))
  }
}
</script>

<style scoped>
@import 'datatables.net-bs5';
@media (max-width: 500px) {
  #employer-cards-table td,
  #employer-cards-table th {
    font-size: 14px;
  }
}

* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

</style>
